<template>
  <div class="box">
    <div class="box-header">
      <ul class="nav nav-tabs nav-tabs-danger nav-justified">
        <li class="nav-item" @click="selected = 'all'">
          <a
            class="nav-link pointer-cursor text-white"
            :class="selected === 'all' ? 'active show' : 'text-muted'"
            >All</a
          >
        </li>
        <li class="nav-item" @click="selected = 'pending'">
          <a
            class="nav-link pointer-cursor text-white"
            :class="selected === 'pending' ? 'active show' : 'text-muted'"
            >Pending</a
          >
        </li>
        <li class="nav-item" @click="selected = 'paid'">
          <a
            class="nav-link pointer-cursor text-white"
            :class="selected === 'paid' ? 'active show' : 'text-muted'"
            >Paid</a
          >
        </li>
      </ul>
    </div>

    <div class="box-body tab-content">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead slot="columns">
            <th class="text-left">ID</th>
            <th class="text-left">Value</th>
            <th class="text-left">Fees</th>
            <th class="text-left">Status</th>
            <th class="text-left">Type</th>
            <th class="text-left">TXID</th>
            <th class="text-right">Date</th>
          </thead>

          <tbody>
            <tr v-for="row in itemsFiltered" :key="row.id">
              <td class="text-left">
                <span class="">{{ row.id }}</span>
              </td>

              <td class="text-left">
                <span class="">{{ row.settle }} {{ row.currency.name }}</span>
              </td>
              <td class="text-left">
                <span class="">{{ row.fees }} {{ row.currency.name }}</span>
              </td>
              <td class="text-left">
                <span
                  class="badge"
                  :class="
                    (row.withdrawal_status === 'paid' && 'badge-success ') ||
                    (row.withdrawal_status === 'pending' && 'badge-warning')
                  "
                >
                  {{ row.withdrawal_status }}
                </span>
              </td>
              <td class="text-left">
                <span class="badge badge-dark">
                  {{ row.withdrawal_type }}
                </span>
              </td>
              <td class="text-left">
                <a
                  :href="`https://explorer.binance.org/tx/${row.txid}`"
                  target="_blank"
                  class="text-success"
                >
                  <small>{{ row.txid }}</small>
                </a>
              </td>
              <td class="text-right">
                <span>{{
                  row.created_at | formatDate("MMMM Do YYYY hh:mm A")
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, formatDollar } from "@/filters";

export default {
  name: "withdrawal-details",
  filters: { formatDate, formatDollar },
  data() {
    return {
      fields: [
        {
          key: "id",
          sortable: true,
          label: "ID",
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "is_daily",
          label: "Daily",
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "txid",
          label: "TXID",
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "value",
          label: "Sub-Total",
          sortable: true,
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "fees",
          label: "Fees",
          sortable: true,
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "settle",
          label: "Total",
          sortable: true,
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "withdrawal_status",
          label: "Status",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "created_at",
          label: "Date",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      loading: false,
      filter: null,
      pageOptions: [5, 10, 15, 20, 25, 30, 40, 50, 100, 500, 1000, 2000],
      sortBy: "order_status",
      sortDesc: true,
      counter: "hello",
      selected: "all",
    };
  },
  computed: {
    itemsFiltered() {
      let result = this.$store.getters.withdrawals;
      if (this.selected !== "all")
        result = this.$store.getters.withdrawals.filter(
          (f) => f.withdrawal_status === this.selected
        );
      return result;
    },
  },
  mounted() {
    this.$store.dispatch("getWithdrawals");
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
